import {Component, Input, OnInit} from '@angular/core';
import { SessionServiceService } from '../services/session-service.service';

@Component({
  selector: 'app-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styleUrls: ['./loading-spinner.component.scss']
})
export class LoadingSpinnerComponent implements OnInit {
  @Input() name: string;

  constructor(public session : SessionServiceService) {

  }

  ngOnInit() {
    console.log(this.name);
  }

}
